$(document).on('ready turbolinks:load', function(){
  $("a[href^='http']:not([href^='http://www.etspraha.cz']):not([href^='http://etspraha.cz']):not([href^='https://www.etspraha.cz']):not([href^='https://etspraha.cz'])").attr("target","_blank");
});

// GA + Turbolinks
document.addEventListener('turbolinks:load', function(event){
  if (typeof(ga) === 'function') {
    ga('set', 'location', event.data.url)
    ga('send', 'pageview')
  }
});

// plausible.io + Turbo
document.addEventListener('turbolinks:load', function() {
  // try { plausible('pageview') }
  // catch(err) { console.log('Plausible: not available.') }
  const user = document.querySelector("meta[name='ets:user']")
  const props = {}
  if (user) { props.user = user.content }
  try {
    umami.track(function(mainProps) {
      const data = { ...mainProps, url: window.location.href, title: document.title, id: props.user }
      return data
    })
  }
  catch(err) { console.log('Umami: error in processing.') }
})

// BS Tools

document.addEventListener("turbolinks:load", () => {
  $('[data-toggle="tooltip"]').tooltip()
  $('[data-toggle="popover"]').popover()
})

// syntax highlighter

import hljs from 'highlight.js'

$(document).arrive('pre code', {existing: true}, function() {
  hljs.highlightAll()
})

// wrap richtext tables with .table-responsive

document.addEventListener("turbolinks:load", () => {
  let tables = document.querySelectorAll('.richtext table')
  tables.forEach((t) => {
    var wrapper = document.createElement('div')
    wrapper.classList.add('table-responsive')
    var copy = t.cloneNode(true)
    wrapper.appendChild(copy)
    t.replaceWith(wrapper)
  })
})
